import { __rest } from "tslib";
import { h } from '@stencil/core';
import url from 'url';
import { productCtas, BAZAAR_VOICE_URL, SPRYKER_PRODUCT_CARD_SECONDARY_PATH, SPRYKER_PRODUCT_CARD_MAIN_PATH, gaLocationNames, isV3, join, isAnalyticsEnabled, validateHost, getLocaleFromBody, deepMerge, tryParse, SprykerProductCardMain, ConfiguratorHandler } from '@pes-ui/utils';
import qs from 'querystring';
import { isBrowser } from '../../globals/utils';
import { getData } from '../../globals/http';
import { getBrandName, getCountry, getLanguage, scrollToTop } from '../../globals/utils/helpers';
import NotificationBannerController from '../UI/pes-notification-banner/controller';
import { getApcCta, getAvailabilityInfo } from '../../globals/apc-cta/api';
import { addToCart, availabilityUrl, formCtaUrl } from '../../globals/apc-cta/utils';
import { getAPCDistributor, getSingleDistributor } from '../commerce-connector/utils';
import { getMyProductsFromConnector } from '../pes-my-products-connector/utils';
export class ProductCardWrapper {
  constructor() {
    var _a;
    this.notificationController = new NotificationBannerController();
    this.gridStateStorageKey = 'pes-uiaas-gridState';
    this.unifiedCheckoutFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.unifiedCheckout;
    this.isUnifiedCheckoutEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.unifiedCheckoutFlag || {});
    this.productPropDefault = 'repositoryId';
    this.productsForCC = [];
    this.additionalDistributors = null;
    this.splitBundlePartNumbers = (partNumber) => {
      if (partNumber.includes(':')) {
        const [basePartNumber, auxPartNumberFull] = partNumber.split(':');
        const [, auxPartNumber] = auxPartNumberFull.split(')');
        return [basePartNumber, auxPartNumber];
      }
      return [partNumber];
    };
    this.handleProductCtasChange = (event) => {
      if (!this.productCtas)
        return;
      this.productCtas = Object.assign(Object.assign({}, this.productCtas), { buttons: event.detail });
    };
    this.host = undefined;
    this.hostWithLocale = undefined;
    this.endpoint = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.productIds = undefined;
    this.parentPage = '';
    this.productOfProductsLabel = undefined;
    this.productsLabel = undefined;
    this.firstRecNum = undefined;
    this.lastRecNum = undefined;
    this.totalNumRecs = undefined;
    this.showHighlightedChar = undefined;
    this.showPrice = undefined;
    this.showDocuments = undefined;
    this.showViewToggle = true;
    this.enableGridViewByDefault = true;
    this.showDownload = undefined;
    this.showViewDetails = undefined;
    this.showBuyOnline = true;
    this.showCompare = false;
    this.enableCartRemove = false;
    this.labels = undefined;
    this.areListGridLabelsShown = true;
    this.products = undefined;
    this.additionalInfos = {};
    this.comparator = {
      list: [],
      isFull: false,
      productProp: 'repositoryId',
    };
    this.buyOnline = {
      list: [],
      productProp: 'repositoryId',
    };
    this.partnerPrices = undefined;
    this.productUrlParams = undefined;
    this.additionalMainQueryParams = undefined;
    this.pdpLinkQueryParams = {};
    this.enableAppRouting = false;
    this.page = '';
    this.pageId = undefined;
    this.enableCommerceConnector = false;
    this.bazaarVoiceEnabled = false;
    this.productsRatings = {};
    this.productCtas = productCtas;
    this.scrollToProduct = undefined;
    this.isAPCSite = false;
    this.agentChatCscId = undefined;
    this.apcCtaUrl = undefined;
    this.apcCta = undefined;
    this.productsAvailabilityInfo = undefined;
    this.siteType = undefined;
    this.localeCode = undefined;
    this.isExternalConsumer = undefined;
    this.externalUrlConfig = undefined;
    this.externalFavoriteConfig = undefined;
    this.showAddToFavorite = undefined;
    this._externalUrlConfig = undefined;
    this._externalFavoriteConfig = undefined;
    this.currentPageStorageKey = undefined;
    this.storageName = undefined;
    this.isProductListing = false;
    this.analyticsPageData = undefined;
    this.productsInfoMap = {};
    this.isGridView = this.showViewToggle
      && sessionStorage.getItem(this.gridStateStorageKey) !== null
      ? sessionStorage.getItem(this.gridStateStorageKey) === 'true'
      : this.enableGridViewByDefault;
    this.ccProductIdToShow = undefined;
    this.ccPricesMap = {};
    this.ccBuyOnlineAvailability = {};
    this.isLoading = true;
  }
  productIdsDidChange() {
    this.loadData();
  }
  optionDidChanged() {
    this.loadData();
  }
  onToggleCardView(event) {
    this.isGridView = event.detail;
    sessionStorage.setItem(this.gridStateStorageKey, event.detail);
  }
  onProductBuyOnlineClick(e) {
    if (this.enableCommerceConnector) {
      const ccProductToShow = this.products.find((product) => product.commercialReference === e.detail.commercialReference);
      this.ccProductIdToShow = ccProductToShow.commercialReference;
    }
  }
  onCCDialogClosed() {
    this.ccProductIdToShow = undefined;
  }
  onCCPricesReceived(e) {
    this.ccPricesMap = e.detail.prices;
    if (e.detail.priceFromLabel) {
      this.labels.partnerPriceLabel = e.detail.priceFromLabel;
    }
  }
  onCCBtnBuyOnlineAvailability(e) {
    this.ccBuyOnlineAvailability = e.detail;
  }
  onApcCtaButtonDidClick(event) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    let gaObj = {};
    const productDetail = this.products.find((item) => item.repositoryId === event.detail.productId);
    if (isAnalyticsEnabled()) {
      const product = {
        brand: 'APC Brand',
        price: (_b = (_a = this.productsAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b[event.detail.productId].activePriceValue,
        category: '',
        id: event.detail.productId,
        name: productDetail.description,
        quantity: 1,
      };
      gaObj = {
        currencyCode: ((_d = (_c = this.productsAvailabilityInfo) === null || _c === void 0 ? void 0 : _c.prices) === null || _d === void 0 ? void 0 : _d[event.detail.productId].activePriceValue)
          ? productDetail.currency
          : 'EUR',
        distributor: '',
        products: [Object.assign(Object.assign({}, product), { variant: '' })],
        isGridView: (_e = this.isGridView) !== null && _e !== void 0 ? _e : false,
      };
    }
    addToCart(this.notificationController, event.detail.productId, this.getLocaleCodes(), (_g = (_f = this.apcCta) === null || _f === void 0 ? void 0 : _f.urls) === null || _g === void 0 ? void 0 : _g.apcHost, (_j = (_h = this.apcCta) === null || _h === void 0 ? void 0 : _h.labels) === null || _j === void 0 ? void 0 : _j.failedResponse, this.agentChatCscId, gaObj, 'addToCartProductCardEvent');
  }
  onCcGetOptionsSucceeded(event) {
    if (event.detail.isApcSite && event.detail.apcCtaUrl) {
      const { isApcSite, apcCtaUrl, agentChatCscId } = event.detail;
      this.isAPCSite = isApcSite;
      this.apcCtaUrl = apcCtaUrl;
      this.agentChatCscId = agentChatCscId;
      if (this.isAPCSite && this.apcCtaUrl) {
        this.requestApcCta(this.apcCtaUrl);
      }
    }
  }
  async requestApcCta(apcCtaUrl) {
    if (isV3()) {
      const countryCode = getCountry(this.localeCode);
      const languageCode = getLanguage(this.localeCode);
      const params = {
        countryCode,
        languageCode,
      };
      this.apcCta = await getApcCta(formCtaUrl(apcCtaUrl, params));
    }
    else {
      this.apcCta = await getApcCta(this.host + apcCtaUrl);
    }
    this.requestProductAvailabilityInfo();
  }
  async requestProductAvailabilityInfo() {
    var _a, _b, _c;
    if ((_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls.apcHost) {
      const requestUrl = availabilityUrl((_c = (_b = this.apcCta) === null || _b === void 0 ? void 0 : _b.urls) === null || _c === void 0 ? void 0 : _c.apcHost, this.getLocaleCodes(), this.productIds.replace(/,/g, '%7C'));
      this.productsAvailabilityInfo = await getAvailabilityInfo(requestUrl);
    }
  }
  async updateProductCtasList(obj) {
    const newProductCtas = Object.assign({}, this.productCtas);
    Object.keys(obj).forEach((type) => {
      newProductCtas.buttons[type].list = obj[type];
    });
    this.productCtas = Object.assign({}, newProductCtas);
  }
  async updateProductCtasButtons(obj) {
    const newProductCtas = Object.assign({}, this.productCtas);
    Object.keys(obj).forEach((type) => {
      deepMerge(newProductCtas.buttons[type], obj[type]);
    });
    this.productCtas = Object.assign({}, newProductCtas);
  }
  getLocaleCodes() {
    const { languageCode, countryCode } = getLocaleFromBody(isBrowser) || {};
    return countryCode && languageCode ? join('/', countryCode, languageCode) : '';
  }
  getComparatorProp() {
    var _a;
    return ((_a = this.comparator) === null || _a === void 0 ? void 0 : _a.productProp) || this.productPropDefault;
  }
  getDataUrl(lastPathFragment, ids, additionalQueryParams) {
    const urlFragments = [];
    if (this.endpoint) {
      urlFragments.push(this.endpoint);
    }
    else {
      urlFragments.push('product');
    }
    urlFragments.push('api');
    urlFragments.push('productCard');
    urlFragments.push(lastPathFragment);
    const parsedHost = url.parse(this.host);
    const urlFormated = url.format({
      protocol: parsedHost.protocol,
      host: parsedHost.host,
      pathname: join(parsedHost.pathname || '', ...urlFragments),
      query: Object.assign({ ids }, additionalQueryParams),
    });
    return urlFormated;
  }
  getProductSecondaryInfoUrl(id) {
    if (isV3()) {
      return `${validateHost(this.host)}${SPRYKER_PRODUCT_CARD_SECONDARY_PATH}?brand=${getBrandName()}&country-code=${getCountry(this.localeCode)}&language-code=${getLanguage(this.localeCode)}&ids=${id}`;
    }
    return this.getDataUrl('addition', id);
  }
  updateProductByInfo(info) {
    const product = this.products.find((prd) => prd.repositoryId === (info === null || info === void 0 ? void 0 : info.productId));
    if (product) {
      this.productsInfoMap[product.repositoryId] = info;
    }
  }
  getReviewsInfo() {
    const partNumbers = this.productIds
      .split(',')
      .reduce((acc, item) => [...acc, ...this.splitBundlePartNumbers(item)], [])
      .join(',');
    const params = qs.stringify({
      apiversion: '5.4',
      passkey: window.bvKey,
      filter: `productid:${partNumbers}`,
      stats: 'Reviews',
    });
    return fetch(`${BAZAAR_VOICE_URL}?${params}`)
      .then((resp) => resp.json())
      .then((data) => this.processBazaarVoiceResponse(data))
      .catch((err) => {
      console.error(err);
    });
  }
  processBazaarVoiceResponse(ratingsData) {
    ratingsData.Results.forEach(({ ProductStatistics }) => {
      const { ProductId, ReviewStatistics: { TotalReviewCount, AverageOverallRating, OverallRatingRange }, } = ProductStatistics;
      this.productsRatings[ProductId] = {
        totalQty: TotalReviewCount,
        rate: AverageOverallRating,
        range: OverallRatingRange,
      };
    });
  }
  getInfoForProducts() {
    let additionalInfos = {};
    Promise.all(this.productIds.split(',').map((id) => getData(false, this.getProductSecondaryInfoUrl(id))
      .then((res) => {
      const { productAdditionalInfos } = res, rest = __rest(res, ["productAdditionalInfos"]);
      this.updateProductByInfo(productAdditionalInfos[0]);
      additionalInfos = Object.assign(Object.assign({}, additionalInfos), { [id]: rest });
      if (productAdditionalInfos[0].apcURL) {
        if (!this.additionalDistributors) {
          this.additionalDistributors = {};
        }
        this.additionalDistributors[id] = [
          getAPCDistributor(productAdditionalInfos[0].apcURL, res.purchaseOnAPCLabel),
        ];
      }
    })
      .catch((error) => console.error(error)))).then(() => {
      this.additionalInfos = additionalInfos;
    });
  }
  getProductCardMainUrl(ids) {
    const { nodeOrSubCatId, isCategoryListing } = this.additionalMainQueryParams || {};
    if (isV3()) {
      return `${validateHost(this.host)}${SPRYKER_PRODUCT_CARD_MAIN_PATH}?brand=${getBrandName()}&country-code=${getCountry(this.localeCode)}&language-code=${getLanguage(this.localeCode)}&ids=${ids}&nodeOrSubCatId=${nodeOrSubCatId}&isCategoryListing=${isCategoryListing}`;
    }
    return this.getDataUrl('main', ids, this.additionalMainQueryParams);
  }
  async getProductCardContent() {
    if (this.isUnifiedCheckoutEnabled) {
      const { languageCode, countryCode } = getLocaleFromBody(isBrowser) || {};
      const { result, error } = await SprykerProductCardMain.getProductCardMain({
        productIdList: this.productIds,
        countryCode,
        languageCode,
      });
      if (error) {
        throw error;
      }
      return result;
    }
    return getData(false, this.getProductCardMainUrl(this.productIds));
  }
  async loadData() {
    var _a;
    if (!this.productIds || !this.productIds.length) {
      return;
    }
    this.isLoading = true;
    try {
      const result = await this.getProductCardContent();
      if (result.selectedNodeId) {
        this.pdpLinkQueryParams.selectedNodeId = result.selectedNodeId;
      }
      if (result.parentSubCategoryId) {
        this.pdpLinkQueryParams.parentSubCategoryId = result.parentSubCategoryId;
      }
      this.labels = result.labels;
      if (!this.enableCartRemove) {
        this.labels.removeFromCartLabel = this.labels.addToCartLabel;
      }
      if ((_a = this.partnerPrices) === null || _a === void 0 ? void 0 : _a.label) {
        this.labels.partnerPriceLabel = this.partnerPrices.label;
      }
      result.products = result.products.map((product) => {
        var _a, _b;
        return (Object.assign(Object.assign({}, product), { marketplacePdpUrl: (_b = (_a = product.marketplacePdpUrl) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, 'cta_location=<location>', `cta_location=${gaLocationNames[this.parentPage] || ''}`) }));
      });
      this.products = result.products;
      this.productsForCC = this.products.map(({ commercialReference, description, pictureUrl: imgUrl, pictureAltText: imgAlt, }) => ({
        commercialReference,
        description,
        imgUrl,
        imgAlt,
      }));
      const isRatingRequest = this.products.find((product) => product.bazaarVoiceEnabled);
      if (this.bazaarVoiceEnabled && isRatingRequest) {
        this.getReviewsInfo();
      }
      this.getInfoForProducts();
    }
    catch (error) {
      console.error(`[PES]: Error fetching products card data:\n${error.message}`);
    }
    finally {
      this.isLoading = false;
    }
  }
  componentWillLoad() {
    var _a, _b;
    this.externalUrlConfig = (_a = tryParse(this._externalUrlConfig)) !== null && _a !== void 0 ? _a : this.externalUrlConfig;
    this.externalFavoriteConfig = (_b = tryParse(this._externalFavoriteConfig)) !== null && _b !== void 0 ? _b : this.externalFavoriteConfig;
    this.loadData();
    this.selfRef.addEventListener('pesLinkClick', ({ detail }) => {
      this.pageId = detail.pageId;
      this.page = detail.page;
    });
  }
  componentDidRender() {
    if (this.productToScrollTo && this.productToScrollTo !== this.lastScrolledToProduct) {
      scrollToTop(this.productToScrollTo);
      this.lastScrolledToProduct = this.productToScrollTo;
    }
  }
  isInCompareList(product) {
    const prop = this.getComparatorProp();
    return this.comparator.list.includes(product[prop]);
  }
  isShowBuyOnline(product) {
    var _a, _b, _c;
    const productIdPropName = ((_a = this.buyOnline) === null || _a === void 0 ? void 0 : _a.productProp) || this.productPropDefault;
    const productId = product[productIdPropName];
    const showBuyOnlineFromOldPesCC = (_c = (_b = this.buyOnline) === null || _b === void 0 ? void 0 : _b.list) === null || _c === void 0 ? void 0 : _c.includes(productId);
    const showBuyOnlineFromNewCC = this.ccBuyOnlineAvailability[productId]
      || (!this.isAPCSite && this.additionalDistributors && !!this.additionalDistributors[productId]);
    return this.enableCommerceConnector ? showBuyOnlineFromNewCC : showBuyOnlineFromOldPesCC;
  }
  getPartnerPrice(product) {
    var _a, _b;
    const idProp = ((_a = this.partnerPrices) === null || _a === void 0 ? void 0 : _a.productProp) || this.productPropDefault;
    const productId = product[idProp];
    if (this.enableCommerceConnector && productId in this.ccPricesMap) {
      return this.ccPricesMap[productId];
    }
    const partnerPrices = ((_b = this.partnerPrices) === null || _b === void 0 ? void 0 : _b.list) || [];
    const partnerPrice = partnerPrices.find((partnerPrice) => partnerPrice.productId === productId);
    return partnerPrice === null || partnerPrice === void 0 ? void 0 : partnerPrice.price;
  }
  render() {
    var _a, _b, _c, _d, _e;
    if (this.isLoading)
      return h("pdp-skeleton", null);
    return (h("div", { class: `cards-wrapper ${this.isGridView ? 'grid-view' : 'list-view'}` }, this.isExternalConsumer && this.showAddToFavorite && (h("pes-range-product-ctas-updater", { buttons: (_a = this.productCtas) === null || _a === void 0 ? void 0 : _a.buttons, myProductsGetter: getMyProductsFromConnector, onChange: this.handleProductCtasChange })), h("div", { class: "cards-wrapper__header" }, !!this.selfRef.querySelector('[slot="title"]') && h("slot", { name: "title" }), this.showViewToggle && (h("pdp-switch-card-view", { isGridView: this.isGridView, productOfProductsLabel: this.productOfProductsLabel, productsLabel: this.productsLabel, firstRecNum: this.firstRecNum, lastRecNum: this.lastRecNum, totalNumRecs: this.totalNumRecs, listViewLabel: (_b = this.labels) === null || _b === void 0 ? void 0 : _b.listViewLabel, gridViewLabel: (_c = this.labels) === null || _c === void 0 ? void 0 : _c.gridViewLabel, areLabelsShown: this.areListGridLabelsShown }))), !!this.selfRef.querySelector('[slot="pills"]') && h("slot", { name: "pills" }), h("ul", { class: "cards-list" }, this.products
      && Array.isArray(this.products)
      && this.products.map((product, index) => {
        const { substitutionLabelRecommendedReplacement, groupOfProductsLabel, pdpViewAllLabel, documentsLabel, downloadButtonLabel, viewOnlineButtonLabel, seeSoftwareButtonLabel, operatingSystemsLabel, sizeLabel, formatLabel, dateLabel, languageLabel, versionLabel, detailsLabel, availableVersionsLabel, } = this.additionalInfos[product.repositoryId] || {};
        const showBazaarVoiceForProduct = (product === null || product === void 0 ? void 0 : product.bazaarVoiceEnabled) || false;
        let buyOnlineStatus = false;
        if (!this.isUnifiedCheckoutEnabled) {
          buyOnlineStatus = this.showBuyOnline && this.isShowBuyOnline(product);
        }
        return (h("li", { class: "cards-item", key: product.repositoryId }, h("product-card", { class: "product_card", ref: (el) => {
            if (index === this.scrollToProduct)
              this.productToScrollTo = el;
          }, host: this.host, hostWithLocale: this.hostWithLocale, productUrlParams: this.productUrlParams, pdpLinkQueryParams: this.pdpLinkQueryParams, isInCompareList: this.isInCompareList(product), isCompareDisabled: this.comparator.isFull && !this.isInCompareList(product), isGridView: this.isGridView, enableAppRouting: this.enableAppRouting, labels: this.labels, product: product, info: this.productsInfoMap[product.repositoryId], substitutionLabelRecommendedReplacement: substitutionLabelRecommendedReplacement, groupOfProductsLabel: groupOfProductsLabel, pdpViewAllLabel: pdpViewAllLabel, documentsLabel: documentsLabel, showPrice: this.showPrice, showHighlightedChar: this.showHighlightedChar, showDocuments: this.showDocuments, showDownload: this.showDownload, showViewDetails: this.showViewDetails, showBuyOnline: buyOnlineStatus, singleDistributor: !this.ccBuyOnlineAvailability[product.repositoryId]
            ? getSingleDistributor(this.additionalDistributors, product.repositoryId)
            : null, showCompare: this.showCompare, partnerPrice: this.getPartnerPrice(product), downloadButtonLabel: downloadButtonLabel, viewOnlineButtonLabel: viewOnlineButtonLabel, seeSoftwareButtonLabel: seeSoftwareButtonLabel, operatingSystemsLabel: operatingSystemsLabel, sizeLabel: sizeLabel, formatLabel: formatLabel, dateLabel: dateLabel, languageLabel: languageLabel, versionLabel: versionLabel, detailsLabel: detailsLabel, availableVersionsLabel: availableVersionsLabel, productCtas: this.productCtas, isAPCSite: this.isAPCSite, apcCta: this.apcCta, productId: product.repositoryId, availabilityInfo: this.productsAvailabilityInfo, bazaarVoiceEnabled: this.bazaarVoiceEnabled && showBazaarVoiceForProduct, productsRatings: this.productsRatings, isExternalConsumer: this.isExternalConsumer, externalUrlConfig: this.externalUrlConfig, currentPageStorageKey: this.currentPageStorageKey, cardMetaData: {
            selectedCardIndex: index,
            currentPageFirstRecNum: this.firstRecNum,
            isListingProducts: this.isProductListing,
          }, analyticsPageData: this.analyticsPageData, localeCode: this.localeCode, parentPage: this.parentPage })));
      })), this.enableCommerceConnector && ((_d = this.productsForCC) === null || _d === void 0 ? void 0 : _d.length) && (h("pes-cc-main", { host: isV3() || this.isExternalConsumer ? this.host : this.hostWithLocale, products: this.productsForCC, productIdToShow: this.ccProductIdToShow, additionalDistributors: !this.isAPCSite && this.additionalDistributors, siteType: this.siteType, localeCode: this.isExternalConsumer && ((_e = this.externalFavoriteConfig) === null || _e === void 0 ? void 0 : _e.localeCode)
        ? this.externalFavoriteConfig.localeCode
        : this.localeCode }))));
  }
  static get is() { return "product-cards-wrapper"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["product-cards-wrapper.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["product-cards-wrapper.css"]
    };
  }
  static get properties() {
    return {
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Host url without language and country codes"
        },
        "attribute": "host",
        "reflect": false
      },
      "hostWithLocale": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "hostWithLocale contains host, countryCode and languageCode"
        },
        "attribute": "host-with-locale",
        "reflect": false
      },
      "endpoint": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "deprecated",
              "text": "not sure if endpoint will be changed."
            }],
          "text": ""
        },
        "attribute": "endpoint",
        "reflect": false
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [{
              "name": "deprecated",
              "text": "please use hostWithLocale to set country code."
            }],
          "text": ""
        },
        "attribute": "country-code",
        "reflect": false
      },
      "languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [{
              "name": "deprecated",
              "text": "please use hostWithLocale to set language code."
            }],
          "text": ""
        },
        "attribute": "language-code",
        "reflect": false
      },
      "productIds": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "ZB4BV003,ZB4BV003S,ZB4BV01"
            }],
          "text": "List of product ids divided by semi to load and show."
        },
        "attribute": "product-ids",
        "reflect": false
      },
      "parentPage": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "PesPageType",
          "resolved": "\"\" | \"all-products\" | \"category\" | \"comparator\" | \"product\" | \"product-cart\" | \"range\" | \"subcategory\"",
          "references": {
            "PesPageType": {
              "location": "import",
              "path": "../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "parent-page",
        "reflect": false,
        "defaultValue": "''"
      },
      "productOfProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "\"1 - 6 of 380 products\"\nRaw string with placeholders for number of displayed records and total number of records."
            }, {
              "name": "example",
              "text": "\"#from what element the product is displayed# - #to what element the product is displayed# of #all the products# products\""
            }],
          "text": "Info about current state of listing."
        },
        "attribute": "product-of-products-label",
        "reflect": false
      },
      "productsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "\"Products\""
            }],
          "text": "String with label that will be displayed if there are less that 11 records."
        },
        "attribute": "products-label",
        "reflect": false
      },
      "firstRecNum": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Number of the first displayed record."
        },
        "attribute": "first-rec-num",
        "reflect": false
      },
      "lastRecNum": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Number of the last displayed record."
        },
        "attribute": "last-rec-num",
        "reflect": false
      },
      "totalNumRecs": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Total number of records."
        },
        "attribute": "total-num-recs",
        "reflect": false
      },
      "showHighlightedChar": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If show highlighted char"
        },
        "attribute": "show-highlighted-char",
        "reflect": false
      },
      "showPrice": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If show prices"
        },
        "attribute": "show-price",
        "reflect": false
      },
      "showDocuments": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If show Documents CTA and documents list"
        },
        "attribute": "show-documents",
        "reflect": false
      },
      "showViewToggle": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If show grid/list view toggle"
        },
        "attribute": "show-view-toggle",
        "reflect": false,
        "defaultValue": "true"
      },
      "enableGridViewByDefault": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Set view (list/grid) by default"
        },
        "attribute": "enable-grid-view-by-default",
        "reflect": false,
        "defaultValue": "true"
      },
      "showDownload": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If show Download CTA"
        },
        "attribute": "show-download",
        "reflect": false
      },
      "showViewDetails": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If show View Details CTA"
        },
        "attribute": "show-view-details",
        "reflect": false
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Show buy online button"
        },
        "attribute": "show-buy-online",
        "reflect": false,
        "defaultValue": "true"
      },
      "showCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If show compare checkboxes."
        },
        "attribute": "show-compare",
        "reflect": false,
        "defaultValue": "false"
      },
      "enableCartRemove": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If show Remove from cart label.\nAvailable only on cart not on my products buttons."
        },
        "attribute": "enable-cart-remove",
        "reflect": false,
        "defaultValue": "false"
      },
      "labels": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "ProductsApi.Labels",
          "resolved": "{ partnerPriceLabel?: string; compareLabel: string; addToMyProductsLabel: string; removeFromMyProductsLabel: string; addToCartLabel: string; removeFromCartLabel: string; buyOnlineLabel: string; viewDetailsLabel: string; shippingLabel: string; deliveryDeadlineLabel: string; gridViewLabel: string; listViewLabel: string; addedToMyProductsLabel: string; removedFromMyProductsLabel: string; viewMyProductsLabel: string; addedToCartLabel: string; removedFromCartLabel: string; viewCartLabel: string; bundleDetails?: string; bundleItems?: string; bundlePrice?: string; bundleAddButton?: string; bundlePriceAll?: string; bundleAddAllButton?: string; purchaseOnAPCLabel?: string; buyMarketplaceLabel?: string; }",
          "references": {
            "ProductsApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Labels used by product cards wrapper component"
        }
      },
      "areListGridLabelsShown": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If list/grid view buttons are shown with labels."
        },
        "attribute": "are-list-grid-labels-shown",
        "reflect": false,
        "defaultValue": "true"
      },
      "products": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "ProductsApi.Product[]",
          "resolved": "Product[]",
          "references": {
            "ProductsApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Products property containing main products information"
        }
      },
      "additionalInfos": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "Record<\n  string,\n  Omit<ProductInfoApi.GetProductsInfoResponse, 'productAdditionalInfos'>\n  >",
          "resolved": "{ [x: string]: Omit<GetProductsInfoResponse, \"productAdditionalInfos\">; }",
          "references": {
            "Record": {
              "location": "global"
            },
            "Omit": {
              "location": "global"
            },
            "ProductInfoApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Additional information used by products cards (e.g. documents, substitutes)"
        },
        "defaultValue": "{}"
      },
      "comparator": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{ list: string[]; isFull: boolean; productProp: string }",
          "resolved": "{ list: string[]; isFull: boolean; productProp: string; }",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Setup comparator logic.\nlist - Contains list of ids of elements in comparator.\nisFull - is comparator full and control should be highlited.\nproductProp - property of product to find in list."
        },
        "defaultValue": "{\n    list: [],\n    isFull: false,\n    productProp: 'repositoryId',\n  }"
      },
      "buyOnline": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{ list: string[]; productProp: string }",
          "resolved": "{ list: string[]; productProp: string; }",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Setup Buy Online logic.\nlist - contains product ids to show buy online button.\nproductProp - property of product to find in list."
        },
        "defaultValue": "{\n    list: [],\n    productProp: 'repositoryId',\n  }"
      },
      "partnerPrices": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{\n    list: {\n      productId: string;\n      price: string;\n    }[];\n    label: string;\n    productProp: string;\n  }",
          "resolved": "{ list: { productId: string; price: string; }[]; label: string; productProp: string; }",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Setup Partner Price logic.\nlist - contains product ids with available partner prices.\nlabel - contains partner price label.\nproductProp - property of product to find in list."
        }
      },
      "productUrlParams": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Parameter for add to to PDP link"
        },
        "attribute": "product-url-params",
        "reflect": false
      },
      "additionalMainQueryParams": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TAdditionalMainQueryParams",
          "resolved": "{ N?: string; isCategoryListing?: boolean; nodeOrSubCatId?: string; }",
          "references": {
            "TAdditionalMainQueryParams": {
              "location": "import",
              "path": "../../globals/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Additional query params for request for products"
        }
      },
      "pdpLinkQueryParams": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TPdpQueryParams",
          "resolved": "{ selectedNodeId?: string; parentSubCategoryId?: string; productUrlParams?: string; }",
          "references": {
            "TPdpQueryParams": {
              "location": "import",
              "path": "../../globals/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Additional query params for links to pdp pages\nMutability caused by necessity to obtain some of the params from main request inside ProductCardWrapper"
        },
        "defaultValue": "{}"
      },
      "enableAppRouting": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "PBS application routing functionality configuration."
        },
        "attribute": "enable-app-routing",
        "reflect": false,
        "defaultValue": "false"
      },
      "page": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "PesPageType",
          "resolved": "\"\" | \"all-products\" | \"category\" | \"comparator\" | \"product\" | \"product-cart\" | \"range\" | \"subcategory\"",
          "references": {
            "PesPageType": {
              "location": "import",
              "path": "../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Catalog level page to show."
        },
        "attribute": "page",
        "reflect": false,
        "defaultValue": "''"
      },
      "pageId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Catalog page id."
        },
        "attribute": "page-id",
        "reflect": false
      },
      "enableCommerceConnector": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Enable Commerce Connector component."
        },
        "attribute": "enable-commerce-connector",
        "reflect": false,
        "defaultValue": "false"
      },
      "bazaarVoiceEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Enable or disable bazaarVoice rating for component"
        },
        "attribute": "bazaar-voice-enabled",
        "reflect": false,
        "defaultValue": "false"
      },
      "productsRatings": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductsRatings",
          "resolved": "{ [x: string]: TRatingData; }",
          "references": {
            "TProductsRatings": {
              "location": "import",
              "path": "../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Ratings from bazaarVoice api"
        },
        "defaultValue": "{}"
      },
      "productCtas": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductCtas",
          "resolved": "{ buttons: TProductCtasButtons; productProp?: string; }",
          "references": {
            "TProductCtas": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Setup productCtas logic.\nbuttons - predefined CTA buttons.\nproductProp - predefined property of product to find in list."
        },
        "defaultValue": "productCtas"
      },
      "scrollToProduct": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Index of the product that should be scrolled into the view after initial rendering\n(for mobile pagination)."
        },
        "attribute": "scroll-to-product",
        "reflect": false
      },
      "isAPCSite": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-a-p-c-site",
        "reflect": false,
        "defaultValue": "false"
      },
      "agentChatCscId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "agent-chat-csc-id",
        "reflect": false
      },
      "apcCtaUrl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "apc-cta-url",
        "reflect": false
      },
      "apcCta": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TApcCta",
          "resolved": "{ urls: { apcHost: string; }; labels: { addToCartButtonLabel: string; vatLabel: string; inStockLabel: string; authToAddToFavorites: string; removeFromFavorites: string; addToFavorites: string; favorites: string; itemAddedTo: string; signIn: string; createAccount: string; itemRemovedFrom: string; failedResponse: string; }; }",
          "references": {
            "TApcCta": {
              "location": "import",
              "path": "../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productsAvailabilityInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductAvailabilityInfo",
          "resolved": "{ howToBuyShowing: { [productId: string]: boolean; }; addToFavoritesInfo: TAddToFavoritesInfo; prices: TPrices; substitution: TSubstitution; factoryStore: TFactoryStore; availability: TAvailability; }",
          "references": {
            "TProductAvailabilityInfo": {
              "location": "import",
              "path": "../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "siteType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "TSiteType",
          "resolved": "\"b2b\" | \"b2c\"",
          "references": {
            "TSiteType": {
              "location": "import",
              "path": "../../globals/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines the context of the app: B2B or B2C"
        },
        "attribute": "site-type",
        "reflect": false
      },
      "localeCode": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "isExternalConsumer": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines consumer is external-user"
        },
        "attribute": "is-external-consumer",
        "reflect": false
      },
      "externalUrlConfig": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TExternalUrlConfig",
          "resolved": "{ viewDetail: string[]; substitution: string[]; }",
          "references": {
            "TExternalUrlConfig": {
              "location": "import",
              "path": "../../globals/external-consumer"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines customized url(s) of hyperlink for external-user"
        }
      },
      "externalFavoriteConfig": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TExternalFavoritelConfig",
          "resolved": "{ host: string; localeCode: string; }",
          "references": {
            "TExternalFavoritelConfig": {
              "location": "import",
              "path": "../../globals/external-consumer"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines favorite configuration for external-user"
        }
      },
      "showAddToFavorite": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Show 'favorite' icon"
        },
        "attribute": "show-add-to-favorite",
        "reflect": false
      },
      "_externalUrlConfig": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-external-url-config",
        "reflect": false
      },
      "_externalFavoriteConfig": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-external-favorite-config",
        "reflect": false
      },
      "currentPageStorageKey": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "SKey for indexDB"
        },
        "attribute": "current-page-storage-key",
        "reflect": false
      },
      "storageName": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "storageName is used as indexDB storage name for breadcrumbs keeping"
        },
        "attribute": "storage-name",
        "reflect": false
      },
      "isProductListing": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-product-listing",
        "reflect": false,
        "defaultValue": "false"
      },
      "analyticsPageData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "MetaTags['analyticsPageData']",
          "resolved": "{ articleTitle: string | number; businessUnit: string; pageRangeId: string; pageSubCategoryId: string; pageCategoryId: string; pageSubCategory: string; pageProductId: string; fromWebView: boolean; digitalPlatform: string; digitalPlatformCountry: string; pageLanguage: string; environment: string; template: string; pageSubSubCategory: string; pageTopCategory: string; pageCategory: string; pageTitle: string; }",
          "references": {
            "MetaTags": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "productsInfoMap": {},
      "isGridView": {},
      "ccProductIdToShow": {},
      "ccPricesMap": {},
      "ccBuyOnlineAvailability": {},
      "isLoading": {}
    };
  }
  static get methods() {
    return {
      "updateProductCtasList": {
        "complexType": {
          "signature": "(obj: { [key: string]: string[]; }) => Promise<void>",
          "parameters": [{
              "tags": [{
                  "name": "param",
                  "text": "obj Object containing key value pairs where key is the Product CTA ID and value is the updated list of product IDs"
                }],
              "text": "Object containing key value pairs where key is the Product CTA ID and value is the updated list of product IDs"
            }],
          "references": {
            "Promise": {
              "location": "global"
            }
          },
          "return": "Promise<void>"
        },
        "docs": {
          "text": "Updates Product CTAs lists with new product IDs",
          "tags": [{
              "name": "param",
              "text": "obj Object containing key value pairs where key is the Product CTA ID and value is the updated list of product IDs"
            }]
        }
      },
      "updateProductCtasButtons": {
        "complexType": {
          "signature": "(obj: { [key: string]: TCTAButtonSettings; }) => Promise<void>",
          "parameters": [{
              "tags": [{
                  "name": "param",
                  "text": "obj new Product CTAs settings"
                }],
              "text": "new Product CTAs settings"
            }],
          "references": {
            "Promise": {
              "location": "global"
            },
            "TCTAButtonSettings": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          },
          "return": "Promise<void>"
        },
        "docs": {
          "text": "Updates Product CTAs state with new Product CTAs settings",
          "tags": [{
              "name": "param",
              "text": "obj new Product CTAs settings"
            }]
        }
      }
    };
  }
  static get elementRef() { return "selfRef"; }
  static get watchers() {
    return [{
        "propName": "productIds",
        "methodName": "productIdsDidChange"
      }, {
        "propName": "host",
        "methodName": "optionDidChanged"
      }];
  }
  static get listeners() {
    return [{
        "name": "toggleCardView",
        "method": "onToggleCardView",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "buyOnlineClick",
        "method": "onProductBuyOnlineClick",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "ccDialogClosed",
        "method": "onCCDialogClosed",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "ccBroadcastPrices",
        "method": "onCCPricesReceived",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "ccBtnBuyOnlineAvailability",
        "method": "onCCBtnBuyOnlineAvailability",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "apcCtaButtonDidClick",
        "method": "onApcCtaButtonDidClick",
        "target": "document",
        "capture": false,
        "passive": false
      }, {
        "name": "ccGetOptionsSucceeded",
        "method": "onCcGetOptionsSucceeded",
        "target": "document",
        "capture": false,
        "passive": false
      }];
  }
}
